import React from "react";
import { TimelineItemProps, useTimelineItem } from "./useTimelineItem";
import {
  timelineItemCardClasses,
  timelineItemContentBoxClasses,
  timelineItemDescriptionClasses,
  timelineItemIconClasses,
  timelineItemTimeClasses,
  timelineItemTitleClasses,
} from "./TimelineItem.style";
import Card from "@/Card";
import CardContent from "@/CardContent";
import Box from "@/Box";
import Typography from "@/Typography";
import { useTimelineContext } from "@/Timeline/TimelineContext";

const TimelineItem: React.FC<TimelineItemProps> = (props) => {
  const { getTimelineItemProps } = useTimelineItem(props);
  const {
    as: Component = "div",
    title,
    description,
    time,
    isNumeric,
    icon,
    ...rest
  } = getTimelineItemProps();

  const { variant, isConnected } = useTimelineContext();

  return (
    <Component {...rest}>
      {/* Icon or dots */}
      <div className={timelineItemIconClasses({ isNumeric })}>
        {icon && (
          <svg
            className="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="10"
          >
            <path
              fillRule="nonzero"
              d="M10.422 1.257 4.655 7.025 2.553 4.923A.916.916 0 0 0 1.257 6.22l2.75 2.75a.916.916 0 0 0 1.296 0l6.415-6.416a.916.916 0 0 0-1.296-1.296Z"
            />
          </svg>
        )}
      </div>
      {/* Card */}
      <Card
        className={timelineItemCardClasses({
          isConnected,
        })}
        outlined
      >
        <CardContent>
          <Box className={timelineItemContentBoxClasses({})}>
            <Typography component="h6" className={timelineItemTitleClasses({})}>
              {title || "Title"}
            </Typography>

            {time && (
              <Typography
                component={"time"}
                className={timelineItemTimeClasses({})}
              >
                {time || "08/06/2023"}
              </Typography>
            )}
          </Box>
          {description && (
            <Typography className={timelineItemDescriptionClasses({})}>
              {description}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Component>
  );
};

export default TimelineItem;
